import type {IProjectConfigDto, IProjectUiDto} from "./project.dto";
import {Model} from "../../_model/Model";
import {SystemFiles} from "./project.constants";

export default class ProjectConfigModel extends Model implements IProjectConfigDto {
    public ui!: IProjectUiDto;
    public projectIdentifier = '';
    public projectName = '';

    public systemFolderId = '';
    public systemFolder = '';
    public logoLightBgUrl = '';
    public logoDarkBgUrl = '';
    public fontLightUrl = '';
    public fontRegularUrl = '';
    public fontBoldUrl = '';

    public async setup(storageUrl: string): Promise<void> {
        // setup paths
        this.systemFolderId = `asf-${this.projectIdentifier}-system-assets`;
        this.systemFolder = `${storageUrl}/assetFolders/${this.systemFolderId}`;
        this.logoLightBgUrl = `${this.systemFolder}/${SystemFiles.LOGO_LIGHT_BG}`;
        this.logoDarkBgUrl = `${this.systemFolder}/${SystemFiles.LOGO_DARK_BG}`;
        this.fontLightUrl = `${this.systemFolder}/${SystemFiles.FONT_LIGHT}`;
        this.fontRegularUrl = `${this.systemFolder}/${SystemFiles.FONT_REGULAR}`;
        this.fontBoldUrl = `${this.systemFolder}/${SystemFiles.FONT_BOLD}`;
        // setup fonts
        const fontLight: FontFace = new FontFace('Audience Project', `url(${this.fontLightUrl})`, {
            style: 'normal',
            weight: '300',
        });
        const fontRegular: FontFace = new FontFace('Audience Project', `url(${this.fontRegularUrl})`, {
            style: 'normal',
            weight: '400',
        });
        const fontBold: FontFace = new FontFace('Audience Project', `url(${this.fontBoldUrl})`, {
            style: 'normal',
            weight: '700',
        });
        await fontLight.load();
        await fontRegular.load();
        await fontBold.load();
        document.fonts.add(fontLight);
        document.fonts.add(fontRegular);
        document.fonts.add(fontBold);
        // setup colors
        document.documentElement.style.setProperty('--color-audience-project-primary', this.ui.primaryColor);
        document.documentElement.style.setProperty('--color-audience-project-secondary', this.ui.secundaryColor);
        document.documentElement.style.setProperty('--color-audience-project-tertiary', this.ui.tertiaryColor);
    }
}
